import React, { memo, useMemo } from 'react';
import { Bar } from 'react-chartjs-2';

const ClickableBarChart = memo(({ data, options, onClick, height = 'h-64' }) => {
  const chartOptions = useMemo(() => ({
    ...options,
    responsive: true,
    maintainAspectRatio: false,
    onClick,
    plugins: {
      ...options.plugins,
      tooltip: {
        ...options.plugins?.tooltip,
        callbacks: {
          afterLabel: () => 'Click to view orders'
        }
      }
    }
  }), [options, onClick]);

  if (!data) return null;

  return (
    <div className={height}>
      <Bar data={data} options={chartOptions} />
    </div>
  );
});

export default ClickableBarChart;
